<template lang="pug">
  v-layout
    v-flex.box-img-icon-formatter
      v-img
        img.icon-cliente(:src="iconMoney" style="vertical-align: middle;height: 2.5em;width: 2.5em;")
    v-flex.box-text-icon-formatter
      span.box-number(style="color: #0855C4;font-size: 24px;font-family: 'Omnes Medium';") {{typeMoney}}{{textMoney || 'mensaje'}}
</template>

<script>
export default {
  props: [
    'iconMoney',
    'textMoney',
    'typeMoney'
  ],
  data() {
    return {
      monto: this.textMoney
    }
  },
  mounted() {
  },
}
</script>

<style scoped>
.box-text-icon-formatter {
  align-self: center;
}

.box-img-icon-formatter {
  align-self: center;
  margin-right: 0.5em;
}
</style>


// WEBPACK FOOTER //
// src/components/generic/IconText.vue